module.exports = { "default": require("core-js/library/fn/array/join"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/array/join.js
// module id = 432
// module chunks = 36